var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signs-calculator" },
    _vm._l(_vm.setting, function(item, key) {
      return _c(
        "span",
        { key: key, staticClass: "signal__container" },
        [
          _c("span", [_vm._v(_vm._s(item.text) + "：")]),
          _vm._v(" "),
          _c("v-icon", { class: item.icon[0] }, [_vm._v(_vm._s(item.icon[1]))]),
          _vm._v(" "),
          _vm.signs_count[item.value]
            ? _c("span", [_vm._v("x " + _vm._s(_vm.signs_count[item.value]))])
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }